import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "signChange",
	standalone: false
})
export class SignChangePipe implements PipeTransform {
	public transform(value: string, [signToChange, targetSign]: [string, string]): string {
		return [...value].map((char: string) => char.replace(signToChange, targetSign)).join("");
	}
}
